export const name = 'dynamicPages' as const
export const DynamicPagesResponseHandlerSymbol = Symbol('DynamicPagesResponseHandlerSymbol')
